import React from 'react';
import ServiceDetailPage from './ServiceDetailPage';
export default function MultiTradeMiami() {
  return <ServiceDetailPage slug="multi-trade-miami" />;
}
